const initialState = () => ({
  recordsInfo: {
    pagination: {},
    items: [],
  },
});

const state = initialState();

export default state;
